// @ts-nocheck
/* eslint-disable */
import SceneMarker from "./marker";

export default class SceneMarkerWindy extends SceneMarker {
	/**
	 * Vytvoreni Windy markeru - dle API.
	 *
	 * @param  {SceneCoords} coords Souradnice
	 * @param  {Number|String} [id] Volitelne ID
	 * @param  {Object} [opts] Volitelny objekt s konfiguraci
	 */
	constructor(scene, itemId, coords, id, opts) {
		super(scene, itemId, coords, id, opts);

		this._conf = Object.assign({}, opts);
		this._conf.type = this._conf.type || this._scene.VISUAL.MARKER_WINDY.UNIVERSAL || {};
		this._poi = null;
		this._active = true;
		this._focus = false;
		this._fromPOI = null;
		this._cardShowed = false;
		this._cardOpts = {};
		this._paddingPosition = null;
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneMarkerWindy",
			type: "marker"
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		let rd = super.getCreateData();

		rd.options = this._conf;
		rd.poi = this._poi;
		rd.active = this._active;
		rd.cardShowed = this._cardShowed;
		rd.focus = this._focus;
		rd.cardOpts = this._cardOpts;
		rd.fromPOI = this._fromPOI;

		if (this._paddingPosition) {
			rd.paddingPosition = this._paddingPosition;
		}

		return rd;
	}

	/**
	 * Naplneni dat markeru z POI dat.
	 *
	 * @param  {Object} poi Vstupni POI data
	 * @param  {String|Number} id Volitelne ID
	 * @param  {Object} opts Konfigurace
	 */
	fromPOI(poi, id, opts) {
		this._poi = poi;
		this._coords = this._scene.coordsFromWGS84(poi.mark.lon, poi.mark.lat);
		this._id = id || this._id;

		let typeId = "universal";

		if (poi.markerId && poi.markerId != "little") { typeId = poi.markerId; }

		let params = {
			type: this._scene.VISUAL.MARKER_WINDY[typeId.toUpperCase()] || {}
		};

		Object.assign(this._conf, Object.assign(params, opts));

		this._fromPOI = {
			poi: poi,
			id: id,
			opts: opts
		};
	}

	/**
	 * Nastaveni POI dat.
	 *
	 * @param {Object} poi POI data
	 */
	setPOI(poi) {
		this._poi = poi;

		this._onChange(this._scene.featureEvent("markerWMSetPOI", true, true), arguments);
	}

	/**
	 * Je marker aktivni?
	 */
	setActive(state = false) {
		this._active = !!state;

		this._onChange(this._scene.featureEvent("markerWMSetActive", true, true), arguments); // pouzit stejnych signalu
	}

	/**
	 * Nastaveni focusu markeru.
	 *
	 * @param  {Boolean} state Novy stav
	 */
	setFocus(state) {
		this._focus = !!state;

		this._onChange(this._scene.featureEvent("markerWMSetFocus", true, true), arguments);
	}

	/**
	 * Vytvoreni vyjizdeci karty (bubliny)
	 *
	 * @param  {Function} cb Callback funkce
	 */
	setPopupCallback(cb) {
		this._cardOpts.cb = cb;

		this._onChange(this._scene.featureEvent("markerPOISetPopupCb", true, true), arguments);
	}

	/**
	 * Vytvoreni vyjizdeci karty (bubliny)
	 *
	 * @param  {Function} cb Callback funkce
	 */
	setPopupCb(cb) {
		this._cardOpts.cb = cb;

		this._onChange(this._scene.featureEvent("markerPOISetPopupCb", true, true), arguments);
	}

	/**
	 * Nastaveni konfigurace pro kartu.
	 *
	 * @param  {Object} options Konfigurace
	 */
	setCardOptions(options) {
		for (var p in options) { this._cardOpts[p] = options[p]; }

		this._onChange(this._scene.featureEvent("markerPOISetCardOptions", true, true), arguments);
	}

	/**
	 * Posunuti karty.
	 */
	moveCard() {
		this._onChange(this._scene.featureEvent("markerPOIMoveCard", true, true), arguments);
	}

	/**
	 * Zobrazeni karty.
	 */
	showCard(timeout?, noSendSignal?) {
		this._cardShowed = true;
		this._onChange(this._scene.featureEvent("markerWMShowCard", true, true), arguments);
	}

	/**
	 * Odebrani karty.
	 */
	removeCard() {
		this._cardShowed = false;
		this._onChange(this._scene.featureEvent("markerPOIRemoveCard", true, true), arguments);
	}

	clearCard() {
		this._onChange(this._scene.featureEvent("markerPOIClearCard", true, true), arguments);
	}

	setLabel(label) {
		this._onChange(this._scene.featureEvent("markerWMSetLabel", true, true), arguments);
	}

	/**
	 * Ziskani POI dat.
	 *
	 * @return {Object}
	 */
	getPOI() {
		return this._poi;
	}

	/**
	 * Ziskani zdroje markeru.
	 *
	 * @return {String}
	 */
	getSource() {
		return this._poi.source;
	}

	/**
	 * Ziskani ID markeru.
	 *
	 * @return {Number}
	 */
	getPlainId() {
		return this._poi.id;
	}

	/**
	 * Ziskani typu markeru.
	 *
	 * @return {Object}
	 */
	getType() {
		return this._conf.type;
	}

	/**
	 * Ziskani konfigurace markeru.
	 *
	 * @return {Object}
	 */
	getConf() {
		return this._conf;
	}

	/**
	 * Ziskani stavu, jestli je marker aktivni?
	 *
	 * @return {Boolean}
	 */
	getActiveFlag() {
		return this._active;
	}

	/**
	 * Ziskani karty (bubliny) markeru.
	 *
	 * @return {Object}
	 */
	getCard() {
		return this._onChange(this._scene.featureEvent("markerWMGetCard", true, true), arguments);
	}

	/**
	 * Nejedna se o detail.
	 *
	 * @return  {Boolean}
	 */
	isDetail() {
		return false;
	}

	getBBox() {
		const mType = this._conf.type;
		const pixel = this._scene.coordsToPixel(this._coords);
		const lt = {
			x: pixel.x - mType.anchor.left,
			y: pixel.y - mType.anchor.top,
		};
		const rb =  {
			x: pixel.x + mType.size[0] - mType.anchor.left,
			y: pixel.y + mType.size[1] - mType.anchor.top,
		};


		return { lt, rb };
	}
}
